import { Breadcrumbs } from "@circleco/compass/components/Breadcrumbs";
import type { BreadcrumbItem } from "@circleco/compass/components/Breadcrumbs";
import { Link, useNavigate } from "@tanstack/react-router";
import { useCallback } from "react";

import { useCanvasInvokeBeforeGoBack } from "./CanvasHeaderContext";
import { useCanvasBreadcrumb } from "./useCanvasBreadcrumb";

export const CanvasBreadcrumb = () => {
  const crumbs = useCanvasBreadcrumb();
  const navigate = useNavigate();
  const invokeBeforeGoBack = useCanvasInvokeBeforeGoBack();

  const handleGuardedClick = useCallback(
    (e: React.MouseEvent, href: string) => {
      e.preventDefault();
      const wasHandled = invokeBeforeGoBack();
      if (!wasHandled) {
        void navigate({ to: href });
      }
    },
    [invokeBeforeGoBack, navigate],
  );

  if (crumbs.length === 0) {
    return null;
  }

  const items: BreadcrumbItem[] = crumbs.map((crumb, index) => {
    const isLast = index === crumbs.length - 1;
    if (crumb.href && !isLast) {
      const { href } = crumb;
      if (crumb.guardNavigation) {
        return {
          label: crumb.label,
          renderLink: (
            <Link to={href} onClick={e => handleGuardedClick(e, href)} />
          ),
        };
      }
      return {
        label: crumb.label,
        renderLink: <Link to={crumb.href} />,
      };
    }
    return { label: crumb.label };
  });

  return (
    <div className="min-w-0 overflow-hidden">
      <Breadcrumbs items={items} size="sm" />
    </div>
  );
};

CanvasBreadcrumb.displayName = "CanvasBreadcrumb";
